:host{display:flex;flex-direction:column;padding:8px 0}mat-slider{--mat-slider-value-indicator-opacity: 1;--mdc-slider-label-container-color: #5a42d0}
/*# sourceMappingURL=view-settings-slider.component.css.map */
